import { Shirt } from "../entities/Shirt";
import { User } from "../entities/User";
import { Image } from "../services/shirts/types";

export interface LoginRole {
  id: number | undefined;
  name: string | undefined;
}
export interface LoginUser {
  id: number | undefined;
  name: string | undefined;
  email: string | undefined;
  role: LoginRole | undefined;
  header_image: Image | undefined;
  profile_image: Image | undefined;
  userData: UserData | undefined;
  username: string | undefined;
  collection: Collection;
  social_networks: Array<SocialNetworksData>;
}
export interface LoginData {
  access_token: string | undefined;
  refresh_token: string | undefined;
  access_token_exp: string | undefined;
  refresh_token_exp: string | undefined;
  user: LoginUser | undefined;
}

export enum roles {
  VISITOR = 0,
  FREE = 1,
  PREMIUM = 2,
}

export interface Collection {
  id: string;
  private: boolean;
}

export interface UserData {
  about_me: string | undefined;
  firstname: string | undefined;
  lastname: string | undefined;
  birthdate: string | undefined; // Consider using a Date type if you handle dates in a specific way
  telephone: string | undefined;
  company: string | undefined;
  country: string | undefined;
  address_1: string | undefined;
  address_2?: string | undefined; // Optional field
  city: string | undefined;
  view_financial_stats: boolean;
  view_numerical_stats: boolean;
}

export interface SocialNetworksData {
  id: number;
  name: string;
  url?: string;
}

export interface TopUser {
  id: number;
  username: string;
  item_count?: number;
  value?: number;
  profile_image: Image | undefined;
  premium?: boolean;
}

export interface UserDataUpdate {
  firstname?: string;
  lastname?: string;
  birthdate?: string; // Consider using a Date type if you handle dates in a specific way
  telephone?: string;
  company?: string;
  country?: string;
  address_1?: string;
  address_2?: string; // Optional field
  city?: string;
}

export const defaultUserData: User = {
  access_token: undefined,
  refresh_token: undefined,
  access_token_exp: undefined,
  refresh_token_exp: undefined,
  userId: undefined,
  userName: undefined,
  role: roles.VISITOR,
  email: undefined,
  profileImage: undefined,
  headerImage: undefined,
  userData: undefined,
  collection: undefined,
  social_networks: [],
  item_count: undefined,
};

export interface LastShirtItem {
  user: User;
  shirt: Shirt;
}

export interface AuthData {
  access_token: string | undefined;
  refresh_token: string | undefined;
  access_token_exp: string | undefined;
  refresh_token_exp: string | undefined;
  userId: string | undefined;
  userName: string | undefined;
  role: roles;
}
